import Badge from "../../../../../styles/customComponents/Badge";
import "./SingleProgram.css";
import moment from "moment";
import { imageLoader } from "../../../../../utils/imageLoader";

const ProgDATA = ({ programme }) => {
  const countDisponibleLots = (programme) => {
    return programme.lots.filter(
      (lot) => lot.disponibility?.disponibilite === "Disponible",
    ).length;
  };
  const countReservedLots = (programme) => {
    return programme.lots.filter(
      (lot) => lot.disponibility?.disponibilite === "Réservé",
    ).length;
  };
  const countOptionnedLots = (programme) => {
    return programme.lots.filter(
      (lot) => lot.disponibility?.disponibilite === "Optionné",
    ).length;
  };

  const formatCertificationStatus = (type, status) => {
    if (type === "not_certified") return "Non certifié";
    if (status === "not_obtained") return "Non obtenu";
    if (status === "obtained") return "Obtenu";
    return "N/C";
  };
  const getProgress = (programme) => {
    const progress =
      (countReservedLots(programme) /
        (countDisponibleLots(programme) +
          countReservedLots(programme) +
          countOptionnedLots(programme))) *
      100;
    if (progress === 0 || isNaN(progress)) return null;
    return progress.toFixed(2) || 0;
  };
  const getBadgeColor = (index) => {
    const colors = [
      "bg-green",
      "bg-blue",
      "bg-purple",
      "bg-orange",
      "bg-pink",
      "bg-yellow",
      "bg-red",
    ];
    return colors[index % colors.length];
  };
  return (
    <div className="progDATA w70 d-flex flex-column gap20">
      {/* Top Section using Grid */}
      <div className="infos d-flex flex-column gap20">
        {/* First Row Grid */}
        <div className="grid-container">
          {/* 2fr column */}
          <div className="grid-item d-flex flex-column gap10">
            <h1 className="semibold fs26 darkGrey">{programme?.name}</h1>
            <p className="darkGrey fs21 regular">
              {programme?.promoteur?.name || "promoteur"}
            </p>
            <p className="darkGrey fs21 semibold">{programme?.address}</p>
            <p className="darkGrey fs21 semibold">
              {programme?.city?.name} {programme?.city?.code}
            </p>
          </div>

          {/* 1fr column */}
          <div className="grid-item d-flex flex-column justify-content-center align-items-center gap10">
            <img
              src={imageLoader(programme?.promoteur?.logo)}
              style={{ objectFit: "contain" }}
              alt="Coffim"
              className="radius5 promoteurLogo"
            />
            <p className="darkGrey fs16 bold">
              {programme?.promoteur?.name || "promoteur"}
            </p>
          </div>

          {/* 1fr column */}
          <div className="grid-item d-flex justify-content-center">
            <div className="position-relative d-flex flex-column justify-content-center align-items-center">
              <img
                src="./assets/progress.png"
                alt="prog_owner"
                className="radius5"
              />
              <span className="progression-programme">
                {getProgress(programme) != null
                  ? `${getProgress(programme)}%`
                  : "0%"}
              </span>
              <p className="semibold fs16 darkGrey">Écoulement</p>
            </div>
          </div>

          {/* 1fr column */}
          <div className="grid-item">
            <div className="d-flex justify-content-between align-items-center fs16 regular h100">
              <div className="d-flex flex-column">
                <p>Lots</p>
                <p>Dispo</p>
                <p>Optionnés</p>
                <p>Réservés</p>
              </div>
              <div className="d-flex flex-column text-end">
                <p>{programme?.lots?.length || 0}</p>
                <p>{countDisponibleLots(programme)}</p>
                <p>{countOptionnedLots(programme)}</p>
                <p>{countReservedLots(programme)}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="separator"></div>

        {/* Programme Information Grid */}
        <div className="grid-container-4">
          {/* Basic Info */}
          <div className="grid-item d-flex flex-column gap20">
            <div className="adresse">
              <p className="semibold fs21 darkgrey">
                Zone {programme?.zone_fiscale || "NC"}
              </p>
            </div>

            {/* Programme Type & Status */}
            <div className="d-flex flex-column gap10">
              {/* Project Types from lots */}
              {programme?.lots?.[0]?.project_types &&
                programme.lots[0].project_types.length > 0 && (
                  <div className="d-flex gap10 flex-wrap">
                    {programme.lots[0].project_types.map(
                      (projectType, index) => (
                        <Badge
                          key={projectType.id}
                          label={projectType.label}
                          BadgeClass={`${getBadgeColor(
                            index,
                          )} px-3 py-2 white radius5 medium fs14`}
                        />
                      ),
                    )}
                  </div>
                )}
            </div>
          </div>
          <div className="grid-item d-flex flex-column align-items-center justify-content-center">
            <img
              src="./icons/offre_speciale.svg"
              alt="key"
              height={30}
              width={30}
              className="mb-10"
            />
            <p className="regular fs14 pink">Offre Spéciale</p>
            <p className="semibold fs17 pink">
              {programme?.has_commercial_offer ? "Oui" : "Non"}
            </p>
          </div>
          {/* Delivery Date */}
          <div className="grid-item d-flex flex-column align-items-center justify-content-center">
            <img
              src="./icons/key.svg"
              alt="key"
              height={30}
              width={30}
              className="mb-10"
            />
            <p className="regular fs14 pink">Livraison</p>
            <p className="semibold fs17 pink">
              {programme?.delivery_date
                ? moment(programme?.delivery_date).format("YYYY") +
                  " T-" +
                  moment(programme?.delivery_date).quarter()
                : "Non Précisée"}
            </p>
          </div>

          {/* Actability */}
          <div className="grid-item d-flex flex-column align-items-center justify-content-center">
            <img
              src="./icons/hand.svg"
              alt="key"
              height={30}
              width={30}
              className="mb-10"
            />
            <p className="regular fs14 pink">Actabilité</p>
            <p className="semibold fs17 pink text-center">
              {programme?.actibility_date != null
                ? moment(programme?.actibility_date).format("YYYY") +
                  " T-" +
                  moment(programme?.actibility_date).quarter()
                : programme?.is_actable
                  ? "Immédiate"
                  : "Non Précisée"}
            </p>
          </div>

          {/* Origin */}
          <div className="grid-item d-flex flex-column align-items-center justify-content-center">
            <img
              src="./icons/bill.svg"
              alt="key"
              height={30}
              width={30}
              className="mb-10"
            />
            <p className="regular fs14 pink">Origine</p>
            <p className="semibold fs17 pink">{programme?.origine || "N/C"}</p>
          </div>
        </div>

        <div className="separator"></div>

        {/* Certification & Technical Info */}
        <div className="grid-container-2">
          <div className="grid-item">
            <div className="certification-info">
              <p className="progDescriptionTitle semibold fs14 darkGrey">
                Certification NF Habitat
              </p>
              <div className="d-flex flex-column gap5 mt-3">
                <p className="fs14">
                  <span className="semibold">Type:</span>{" "}
                  {formatCertificationStatus(programme?.nf_habitat_type)}
                </p>
                <p className="fs14">
                  <span className="semibold">Statut:</span>{" "}
                  {formatCertificationStatus(
                    null,
                    programme?.nf_habitat_status,
                  )}
                </p>
                {programme?.nf_habitat_certificat && (
                  <p className="fs14">
                    <span className="semibold">Certificat:</span>{" "}
                    {programme.nf_habitat_certificat}
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="separator"></div>

      {/* Description Section */}
      <div className=" progDescription">
        <p className="progDescriptionTitle semibold fs14 darkGrey">
          Description
        </p>
        <div
          className="progDescriptiontext mt-3"
          dangerouslySetInnerHTML={{
            __html: programme?.description || "Non Précisée",
          }}
        />
      </div>
    </div>
  );
};

export default ProgDATA;
